module.exports = __webpack_public_path__ + "static/media/wind-turbine_blue.f54ae3cc.svg";